// utils/loadingHelper.js
let setLoadingGlobal;

export const setLoadingSetter = (setter) => {
  setLoadingGlobal = setter;
};

export const getLoadingSetter = () => setLoadingGlobal;
